//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var bgImageList = ['linear-gradient(134deg, #73583F 0%, #73583F 38%, rgba(115,88,63,0.80) 67%, rgba(115,88,63,0.50) 100%)', 'linear-gradient(135deg, #4A4773 0%, #4D4B73 37%, rgba(77,75,115,0.80) 68%, rgba(77,75,115,0.50) 100%)', 'linear-gradient(135deg, #6E4242 0%, #6E4242 38%, rgba(110,66,66,0.80) 67%, rgba(110,66,66,0.50) 100%)', 'linear-gradient(136deg, #42506E 0%, #42506E 40%, rgba(66,80,110,0.80) 69%, rgba(66,80,110,0.50) 100%)', 'linear-gradient(136deg, #3E5D63 0%, #3E5D63 42%, rgba(62,93,99,0.80) 69%, rgba(62,93,99,0.50) 100%)'];
export default {
  name: 'what-look',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      bgImageList: bgImageList
    };
  },
  methods: {
    toShowMore: function toShowMore(item) {
      var rankId = item.rankId,
          dataSeed = item.dataSeed;

      if (dataSeed) {
        window.seedAction(dataSeed);
      }

      this.go("/top/".concat(rankId, "?type=1"));
    }
  }
};